const BASE_URL ="https://arts-and-crafts.onrender.com";

export const API_URL = (slug) => `${BASE_URL}/${slug}`;